import { createStore } from "./utils";

interface UserTimelineSettings {
  combineAllSMSItems: boolean;
}

const DEFAULT_USER_TIMELINE_SETTINGS: UserTimelineSettings = {
  combineAllSMSItems: false,
} as const;

interface TimelineSettingsStore {
  userSettings: Record<string, UserTimelineSettings>;
  setUserSetting: <T extends keyof UserTimelineSettings>(
    userId: string,
    settingName: T,
    val: UserTimelineSettings[T]
  ) => void;
  setUserSettings: (userId: string, settings: UserTimelineSettings) => void;
}

export const { useStore: useTimelineSettingsStore, useShallowStore: useShallowTimelineSettingsStore } =
  createStore<TimelineSettingsStore>(
    (set) => ({
      userSettings: {},
      setUserSetting: <T extends keyof UserTimelineSettings>(
        userId: string,
        settingName: T,
        val: UserTimelineSettings[T]
      ) => {
        set((state) => {
          const currentUserSettings = state.userSettings[userId] ?? DEFAULT_USER_TIMELINE_SETTINGS;
          return {
            userSettings: {
              [userId]: {
                ...currentUserSettings,
                [settingName]: val,
              },
            },
          };
        });
      },
      setUserSettings: (userId, settings) => {
        set(() => {
          return {
            userSettings: {
              [userId]: settings,
            },
          };
        });
      },
    }),
    {
      persist: "localStorage",
      name: "TIMELINE_SETTINGS",
    }
  );
